import superagent from 'superagent';
import config from 'config';
import env from 'env';
import {noNullDeepClone} from 'utils/commonUtils'

const methods = ['get', 'post', 'put', 'patch', 'del'];

export default class ApiClient {
  constructor(agent = false) {

    methods.forEach((method) =>
      this[method] = (path, { params, data, withCredentials } = {}, headers = {}) => new Promise((resolve, reject) => {

        let univesalPath;
        if (typeof window === 'undefined' || env.API_CROSS_ORIGIN_DISABLED !== 'true') {
          univesalPath = `${config.apiProtocol}://${config.apiUrl}:${config.apiPort}/${path}`;
        } else {
          univesalPath = `/${path}`;
        }

        const request = superagent[method](univesalPath);

        if (agent) {
          request._agent = agent;
        }

        if(headers){
          request.set(headers);
        }

        if (params) {
          request.query(params);
        }

        if (config.cacheBuster && (method === "get")) {
          request.query({"sl_cb":config.cacheBuster});
        }

        request.timeout(config.apiTimeout);

        if (withCredentials) {
          request.withCredentials();
        }

        if (data) {
          request.send(data);
        }

        request.end((err, { body } = {}) => {
          const cleanBody = noNullDeepClone(body);

          if (err) {
            reject({
              body: cleanBody,
              status: err.status,
              error: err
            });
          }
          else {
            resolve(cleanBody);
          }
        });
      }));
  }

  init() {

  }

  /*
   * Relevant bug: https://phabricator.babeljs.io/T2455
   * Recommended not to use classes with just a constructor.
   */
  empty() {}
}



// WEBPACK FOOTER //
// ./utils/ApiClient.js